import type { WorkOrder } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/workOrder/utils/fields';
import { getHistorySection } from '#/common/utils/fields/historySection';

const fields: FormItem<WorkOrder & { traneSupplySearch: unknown }>[] = [
  {
    colCount: {
      xs: 1,
      sm: 1,
      md: 4,
      lg: 4,
    },
    cssClass: 'tmm-section-no-background',
    caption: 'Work Order Details',
    items: [
      {
        colCount: 1,
        colSpan: 1,
        items: [allFields.tenantId],
      },
      {
        colCount: 1,
        colSpan: 1,
        items: [allFields.findingId],
      },
      {
        colCount: 1,
        colSpan: 1,
        items: [allFields.asset],
      },
      {
        colCount: 1,
        colSpan: 1,
        items: [allFields.traneSupplySearch],
      },
    ],
  },
  {
    colCount: 6,
    cssClass: 'tmm-section tmm-section-no-caption',
    items: [
      {
        ...allFields.title,
        colSpan: 6,
      },
      {
        ...allFields.state,
        colSpan: 2,
      },
      {
        ...allFields.priority,
        colSpan: 2,
      },
      {
        ...allFields.impact,
        colSpan: 2,
      },
      {
        ...allFields.category,
        colSpan: 2,
      },
      {
        ...allFields.type,
        colSpan: 2,
      },
      {
        ...allFields.assignedTo,
        colSpan: 2,
      },
      {
        ...allFields.description,
        colSpan: 6,
      },
    ],
  },

  {
    colCount: 3,
    cssClass: 'tmm-section',
    caption: 'Schedule',
    items: [
      { ...allFields.plannedStartDate, colSpan: 1 },
      { ...allFields.plannedEndDate, colSpan: 1 },
      { ...allFields.dueDate, colSpan: 1 },
      { ...allFields.startDate, colSpan: 1 },
      { ...allFields.endDate, colSpan: 1 },
      { ...allFields.duration, colSpan: 1 },
    ],
  },

  {
    colCount: 4,
    cssClass: 'tmm-section',
    caption: 'Resolution',
    items: [
      allFields.closedAt,
      allFields.closedBy,
      allFields.actualCostValue,
      allFields.actualEffort,
      { ...allFields.closedNotes, colSpan: 4 },
    ],
  },
  getHistorySection(),
];

export default fields;
